import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Snackbar from './components/Widgets/Snackbar';
import Authorizer from './Authorizer';

const Router = (props) => {
    return (
        <React.Fragment>
            <Snackbar />
            <BrowserRouter>
                <Routes>
                    <Route path="*" element={<Authorizer />} />
                </Routes>
            </BrowserRouter>
        </React.Fragment>
    );
};

export default Router;
